/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-03-17 10:03:48
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-03-18 12:08:03
 * @FilePath: /intl-m-jdi-website-ssr/src/app/cms/[pageCode]/pvModule.tsx
 * @Description: default
 */
'use client';
import { sendPv } from '../tempo_track';
import { useEffect, useState } from 'react';
import PVComponent from '@/components/PVComponent';
import HEADER_PAGE_TYPE from '@/constants/header';
interface PvProps {
  pageCode: string;
  pageType: string;
}
export default function PvModule({ pageCode, pageType }: PvProps) {
  const [miniHomeIndex, setMiniHomeIndex] = useState(-100);

  // 获取 miniHome 组件中对应 pageCode 的 tab index
  const getMiniHomeTabIndex = (targetPageCode: string) => {
    // 确保在minihome内找tab的id tab的id格式为：${pageCode}_${index}
    const miniHomeContainer = document.getElementById('miniHome');

    if (miniHomeContainer) {
      const targetTab = miniHomeContainer.querySelector(`[id^="${targetPageCode}_"]`);
      if (targetTab) {
        const index = parseInt(targetTab.id.split('_')[1]);
        return index;
      } else {
        return -100;
      }
    } else {
      return -100;
    }
  };

  useEffect(() => {
    // 如果是普通活动页面，则在浏览器上报pv
    if (pageType === HEADER_PAGE_TYPE.NORMAL) {
      sendPv.cms_TempoPage({ page_id: pageCode });
    }

    // 获取当前页面在 miniHome 中的 tab index
    else if (pageType === HEADER_PAGE_TYPE.MINIHOME) {
      const timer = setTimeout(() => {
        const index = getMiniHomeTabIndex(pageCode);
        setMiniHomeIndex(index);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [pageCode]);

  return pageType === HEADER_PAGE_TYPE.HOME ? (
    <PVComponent spm={'a0145.b002218'} page_id={'Home_Main'} />
  ) : miniHomeIndex !== -100 ? (
    <PVComponent
      spm={'a0145.b002244'}
      page_id={'Mini_Hp'}
      page_param={{ index: miniHomeIndex, Mini_Hp_Name: pageCode }}
    />
  ) : null;
}
